export default __webpack_public_path__ + "static/media/Flat_Red.c23f01e1.png";